export default __webpack_public_path__ + "static/Conference-4e56be9ecd54d39121d9412ad0a36686.svg";